import { codeSplit, Controller, FetchOptions, Result } from 'bernie-core';
import { PageData } from 'bernie-http';
import '../client/temp-common-imports';

export class PzSignupConfirmationController implements Controller {
  public pageId = 'PzSignupConfirmation';
  public path = '/:localeName/pz-signup-confirmation';
  public routeName = 'pz-signup-confirmation';
  public bundles = [];

  public component = codeSplit(
    () => import(/* webpackChunkName: "uis-prime-example-page" */ '../views/pz-signup-confirmation-page'),
  );

  public exact = true;

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({ title: 'PZ SignUp Confirmation' }) as Promise<PageData>;
  }
}
